import {deserializeAs} from 'libs/cerialize';
import {GridDataModel} from 'Core/Controls/Grid/Models/GridDataModel/GridDataModel';

export class GroupDetailModel {
    @deserializeAs(GridDataModel)
    Data: GridDataModel;
}